<template>
  <anchor-link
    :href="href"
    :class="{
    'button--is-small': isSmallButton,
    'button--is-justify-start': isJustifyStart,
    }"
    class="button"
  >
    <icon-font
      :name="iconName"
      class="button__icon"
    />
    <p class="button__title">{{ title }}</p>
    <div v-if="subtitle" class="button__subtitle subtitle">
      <icon-premium />
      <p>{{ subtitle }}</p>
    </div>
  </anchor-link>
</template>

<script>
import { titledLinkProps } from '@/mikan/_shared/types/vueTypes/anchorLink';
import AnchorLink from '@/mikan/_shared/components/atoms/AnchorLink.vue';
import IconFont from '@/mikan/_shared/components/atoms/icons/IconFont.vue';
import IconPremium from '@/mikan/_shared/components/atoms/icons/IconPremium.vue';

export default {
  components: {
    AnchorLink,
    IconFont,
    IconPremium,
  },
  props: {
    ...titledLinkProps,
    iconName: {
      type: String,
      required: true,
    },
    isSmallButton: {
      type: Boolean,
      default: false,
    },
    isJustifyStart: {
      type: Boolean,
      default: false,
    },
    isPremiumOnly: {
      type: Boolean,
      default: false,
    },
    isFreeMember: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    subtitle() {
      return this.isFreeMember && this.isPremiumOnly ? '有料プラン限定' : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';

.button {
  $root: &;

  display: flex;
  height: 100%;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid $color-navy-20;
  background-color: $color-white;
  border-radius: 4px;
  transition: background-color $transition-interaction;

  @include is-pointer-device {
    &:hover {
      background-color: $color-orange-ultra-light;
    }
  }

  &__icon {
    color: $color-orange;
    font-size: 50px;
  }

  &__title {
    color: $color-orange;
    font-weight: bold;

    @include for-tb-pc {
      font-size: 16px;
    }

    @include for-sp {
      font-size: 14px;
    }

    &:nth-child(n + 2) {
      margin-top: 2px;
    }
  }

  &--is-small {
    flex-direction: row;

    #{$root}__icon {
      font-size: 32px;
    }

    #{$root}__title {
      &:nth-child(n + 2) {
        margin-top: 0;
        margin-left: 6px;
        font-size: 14px;
      }
    }
  }

  &--is-justify-start {
    justify-content: start;
  }
}

.subtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  color: $color-green;
  gap: 4px;

  @include for-tb-pc {
    font-size: 12px;
  }

  @include for-sp {
    // レイアウト崩してまでspに表示するのは避ける理由で非表示
    // https://retty.slack.com/archives/C05EPTLKMTP/p1742351928697269?thread_ts=1742347516.023479&cid=C05EPTLKMTP
    display: none;
  }
}
</style>
